// import * as clipboard from 'clipboard-polyfill/text'

export const isMobilePattern = (phone: string): boolean => {
  const mobilePattern = /^(\+886|0)?9[0-9]{8}$/
  return mobilePattern.test(phone)
}

/*
 transform phone number to +886 format.
 types:
 (1) 09xxyyyzzz => +8869xxyyyzzz
 (2) any other: original (trimmed)
 */
export function to886(phone: string): string | null {
  if (typeof phone !== 'string') return null
  phone = phone.trim()

  if (/^09[0-9]{8}$/.test(phone)) {
    return '+886' + phone.substring(1)
  }

  return phone
}

export function remove886(phone: string): string | null {
  if (typeof phone !== 'string') return null
  phone = phone.trim()

  if (/^8869[0-9]{8}$/.test(phone)) {
    return '0' + phone.substring(3)
  }

  if (/^\+8869[0-9]{8}$/.test(phone)) {
    return '0' + phone.substring(4)
  }

  return phone
}

/** 
 transform phone number to 0911-123-456 format
*/
export function toSegmentedPhoneNumber(phone: string): string {
  if (typeof phone === 'string' && phone.length === 10) {
    return phone.replace(/(\d{4})(\d{3})(\d{3})/g, '$1-$2-$3')
  }
  return phone
}

export const isIOS = /ipad|iphone/.exec(navigator.userAgent)
export const isAndroid = /android/.exec(navigator.userAgent)

export const formatNumber = (src: number): string => {
  if (Number.isNaN(src) || typeof src !== 'number') {
    return ''
  }
  const parts = src.toString().split('.')
  parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(\.\d+)?$)/g, '$1,')
  return parts.join('.')
}

export function alterArrayItem<T>(
  array: Array<T>,
  newItem: T,
  atIndex: number,
): Array<T> {
  if (atIndex < 0 || atIndex >= array.length) return array
  return [...array.slice(0, atIndex), newItem, ...array.slice(atIndex + 1)]
}

export function roundPrecision(input: number, precision = 1): number {
  const multiplier = Math.pow(10, precision)
  return Math.round(input * multiplier) / multiplier
}

// TODO [future] use library
export function withQuerystring(
  path: string,
  key: string,
  value: string,
): string {
  return `${path}${value ? `?${key}=${value}` : ''}`
}

export function rand(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min) + min)
}

// const copyStringToClipboard = str => {
//   const el = document.createElement('textarea')
//   el.value = str
//   document.body.appendChild(el)
//   if (isIOS) {
//     const range = document.createRange()
//     const selection = window.getSelection()
//     range.selectNode(el)
//     selection.removeAllRanges()
//     selection.addRange(range)
//   } else {
//     el.select()
//   }
//   const res = document.execCommand('copy')
//   el.remove()
//   return res
// }
